import React, { useEffect, useState } from 'react';
import RenderFieldBasedOnType from '../RenderFieldsBasedOnType';
import {
    Box,
    Grid,
    Typography,
    Tooltip
} from '@material-ui/core'
import { Helpers } from "dsilo-ui-components";
import { makeStyles } from '@material-ui/core/styles';
import SubDataModelTaskViewer from "../SubDataModelTask"
// import { padding } from 'polished'; // (optional) not used

/* NEW: responsive card styles */
import { useCardStyles, useCommonStyles, useInputStyles } from './style';

/* For now It is static */
const defaultOptions = {}

const SummaryBlock = (props) => {
    const layoutClasses = useCommonStyles()
    const inputClasses = useInputStyles();
    const cardClasses = useCardStyles(); // NEW

    const { currentDocumentId, formData, selectedStep, block, blockState, handleCheckboxChange, onChange } = props
    const { chartUniqueId } = props.data

    const [blockHeaders, setBlockHeaders] = useState([])
    const [allTasksCompleted, setAllTasksCompleted] = useState(false);
    const shouldDisableFields = props.shouldDisableFields

    const getCardValue = (blockState, block, dataElementKey, defaultText) => {
        return blockState?.[dataElementKey] ||
            blockState?.[dataElementKey] ||
            blockState?.[dataElementKey] ||
            defaultText;
    };

    console.log('block**props', props.enableWorkflow)

    /* CHANGED: responsive card rendering */
    const renderCard = (card, cardValue, index) => {
        const hasData = cardValue && cardValue !== card.defaultText && cardValue.trim() !== '';

        return (
            <div
                key={`${card.value}_${index}`}
                className={`${cardClasses.cardRoot} ${hasData ? cardClasses.cardRootHasData : ''}`}
                style={{
                    // pass colors in as CSS vars the JSS uses
                    '--card-bg': card.backgroundColor,
                    '--card-border': card.borderColor,
                }}
            >
                <div className={cardClasses.cardIconWrap}>
                    <img
                        src={card.icon}
                        alt={card.title}
                        width={card.title === "Obligation Language" ? 18 : 23}
                        height={card.title === "Obligation Language" ? 18 : 23}
                    />
                </div>

                <div className={cardClasses.cardBody}>
                    <Typography
                        className={cardClasses.cardTitle}
                        style={{ color: card.titleColor }}
                    >
                        {card.title}
                    </Typography>

                    <Typography
                        className={`${cardClasses.cardText} ${hasData ? cardClasses.cardTextHasData : cardClasses.cardTextEmpty} myScrollContainer`}
                    >
                        {cardValue}
                    </Typography>
                </div>
            </div>
        );
    };

    const renderDynamicCards = (blockState, block) => {
        const cardValue = getCardValue(blockState, block, block.value, block.defaultText);
        return (
            <div className={cardClasses.cardsColumn}>
                {renderCard(block, cardValue, 0)}
            </div>
        );
    };

    useEffect(() => {
        if (formData?.dataModel[selectedStep.dataModel]) {
            let dataElements = formData.dataModel[selectedStep.dataModel].dataElements || []
            if (dataElements?.length) {
                let fdes = []
                if (block?.config?.dataElements) {
                    fdes = JSON.parse(JSON.stringify(block?.config?.dataElements))
                    fdes = fdes.map(fde => {
                        let sde = dataElements.find(de => de.name === fde.value)
                        if (sde?.name) {
                            return { ...sde, ...fde }
                        } else {
                            return fde
                        }
                    })
                    setBlockHeaders(fdes)
                }
            }
        }
    }, [formData?.dataModel, selectedStep?.dataModel, block?.config?.dataElements])

    const showHideWorkFlow = (obj) => {
        setAllTasksCompleted(obj)
        props.showHideWorkFlow(obj)
    }

    return (
        <React.Fragment>
            <div className={layoutClasses.columnContainer}>
                {
                    props.isSubBlock ? (<Tooltip title={block?.name || ''} arrow>
                        <Typography
                            component='span'
                            noWrap
                            className={`${layoutClasses.sectionTitleText} ${layoutClasses.sectionTitleTextClamp}`}
                        >
                            {block.name} :
                        </Typography>
                    </Tooltip>) : null
                }
                <Grid container spacing={1}>
                    {
                        blockHeaders?.length > 0 ? blockHeaders.map((element, index) => {
                            const isFieldReadOnly = shouldDisableFields || element.readOnly;

                            if ((!props.enableWorkflow) && (element?.isCustomType?.enable === true && element?.isCustomType?.type === "linkedReferenceTasks")) {
                                return null;
                            }
                            return (
                                <Grid
                                    item
                                    key={index}
                                    xs={element.xs ? element.xs : (12 / blockHeaders.length)}
                                    className={layoutClasses.gridItemMargins}
                                >
                                    {
                                        element?.isCustomType?.enable === true && element?.isCustomType?.type === "linkedReferenceTasks" ? (
                                            props.enableWorkflow ? (<SubDataModelTaskViewer {...props} element={element} eachBlock={element?.isCustomType} block={element?.isCustomType} keyName={element?.isCustomType?.dataModel} currentOpportunityId={currentDocumentId} shouldDisableFields={shouldDisableFields} showHideWorkFlow={showHideWorkFlow} />) : null
                                        ) : element?.isCustomType?.enable === true && element?.isCustomType?.type === "card" ? (
                                            renderDynamicCards(blockState, element?.isCustomType)
                                        ) : (
                                            <Box className={layoutClasses.fullWidthBox}>
                                                <Grid container>
                                                    <div className={layoutClasses.labelRow}>
                                                        <Tooltip title={element?.label || ''} arrow>
                                                            <Typography
                                                                component='span'
                                                                className={`${layoutClasses.fieldLabel} ${layoutClasses.fieldLabelClamp}`}
                                                            >
                                                                {element.label} :
                                                            </Typography>
                                                        </Tooltip>
                                                    </div>

                                                    <div className={layoutClasses.fieldWrapper}>
                                                        <RenderFieldBasedOnType
                                                            {...props}
                                                            classes={layoutClasses}
                                                            element={isFieldReadOnly ? { ...element, readOnly: true } : element}
                                                            onChange={onChange}
                                                            handleCheckboxChange={handleCheckboxChange}
                                                            dataObj={blockState}
                                                            options={defaultOptions[element.value || element.name]}
                                                            selectedStep={selectedStep}
                                                            inputClasses={inputClasses}
                                                        />
                                                    </div>
                                                </Grid>
                                            </Box>
                                        )
                                    }
                                </Grid>
                            )
                        }) : (
                            <Typography>{`No Fields are Configured`}</Typography>
                        )
                    }
                </Grid>
            </div>
        </React.Fragment>
    )
}

export default SummaryBlock
